import {
	createFileRoute,
	redirect,
	useParams,
	useRouter,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import {
	apiClient,
	requestWithHandling,
	TypedClientApiError,
} from "@/utils/api";

export const Route = createFileRoute("/_authorized/user/verify-email/$token")({
	component: VerifyEmail,
});

export function VerifyEmail() {
	const router = useRouter();
	const { token } = useParams({
		from: "/_authorized/user/verify-email/$token",
	});

	const onSubmit = async () => {
		if (!token) {
			router.navigate({ to: "/user/settings" });
			return;
		}
		try {
			await requestWithHandling<void>(() =>
				apiClient.api.authVerifyEmailCreate(token),
			);
			toast.success("Email verified");
			router.navigate({ to: "/user/settings" });
		} catch (error) {
			toast.error("Verification failed", {
				description:
					error instanceof TypedClientApiError
						? error.message
						: "An unknown error occurred.",
			});
			router.navigate({ to: "/user/settings" });
		}
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: Can't use exhaustive dependencies here
	useEffect(() => {
		onSubmit();
	}, []);

	if (!token) {
		return redirect({ to: "/user/settings" });
	}

	return null;
}
